import { z } from 'zod';
import { ErpSyncSystemStatus } from '../erp-system-status.enum';
import { EnumSchema } from '@40seas/entities/common';
import { ExternalEntityStatus } from '@40seas/entities/external-entities';

const erpSyncStatusKeys = [...Object.values(ExternalEntityStatus), 'out-of-sync'] as const;

export type ErpSyncSummaryStatuses = {
    [K in ExternalEntityStatus]?: number;
} & { 'out-of-sync'?: number };

export const ErpSyncSummaryStatusesSchema = z.object(Object.fromEntries(erpSyncStatusKeys.map((key) => [key, z.number().optional()])));

export const ErpSyncSummarySchema = z.object({
    buyers: ErpSyncSummaryStatusesSchema.optional(),
    invoices: ErpSyncSummaryStatusesSchema.optional(),
    payments: ErpSyncSummaryStatusesSchema.optional(),
    payoutsStatus: EnumSchema(ErpSyncSystemStatus),
    systemStatus: EnumSchema(ErpSyncSystemStatus),
});

export class ErpSyncSummary {
    buyers?: ErpSyncSummaryStatuses;
    invoices?: ErpSyncSummaryStatuses;
    payments?: ErpSyncSummaryStatuses;
    payoutsStatus: ErpSyncSystemStatus;
    systemStatus: ErpSyncSystemStatus;
}
